import brakesIcon from '~/assets/icons/brakes.svg';
import suspension from '~/assets/icons/suspension.svg';
import transmission from '~/assets/icons/transmission.svg';
import wheel from '~/assets/icons/wheel.svg';
import { HandlingMode, TechTuningSection } from '~/shared';

export const techTuningSectionName: Record<TechTuningSection, string> = {
	[TechTuningSection.TRANSMISSION]: 'Трансмиссия',
	[TechTuningSection.SUSPENSION]: 'Подвеска',
	[TechTuningSection.ENGINE]: 'Двигатель',
	[TechTuningSection.BRAKES]: 'Тормозная система',
	[TechTuningSection.TYRES]: 'Сцепление',
};

export const modeList = [
	{
		name: HandlingMode.Comfort,
		title: 'Comfort',
	},
	{
		name: HandlingMode.Sport,
		title: 'Sport',
	},
	{
		name: HandlingMode.Drift,
		title: 'Drift',
	},
];

export const handlingIcons = {
	acceleration: transmission,
	brakes: brakesIcon,
	traction: wheel,
	suspension: suspension,
	other: transmission,
};
